import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    debug: true,

    ns: ["translation", "terms", "privacy", "qa", "support"], // 🧠 Declare all namespaces
    defaultNS: "translation", // default for general UI

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // 🔄 Dynamic namespace loading
    },
  });

export default i18n;
